import i18n from '@/lang/'
import Vue from 'vue'
import moment from 'moment'
import * as Constants from '@/constants'

export function deepTrim(obj) {
  for (var prop in obj) {
    var value = obj[prop],
      type = typeof value
    if (value != null && (type == 'string' || type == 'object') && obj.hasOwnProperty(prop)) {
      if (type == 'object') {
        deepTrim(obj[prop])
      } else {
        obj[prop] = obj[prop].trim()
      }
    }
  }
}

export function displayLongDateTime(date) {
  if (date) {
    return moment
      .utc(date)
      .tz(moment.tz.guess())
      .format(i18n.t('xLongDateTime'))
  } else return null
}

export function displayShortDate(date, shouldIgnoreTimezone = false) {
  if (date) {
    if (shouldIgnoreTimezone) {
      // ML-2116 - adding this to fix issues with simple dates being changed by tz adjustment
      // Whether the timezone check is needed in the first place is unclear, but I would rather not rock the boat here
      return moment.utc(date).format(i18n.t('xShortDate'))
    }

    return moment
      .utc(date)
      .tz(moment.tz.guess())
      .format(i18n.t('xShortDate'))
  } else {
    return 'N/A'
  }
}

export function displayExtraShortTimeWithTZ(date) {
  if (date) {
    return moment
      .utc(date)
      .tz(moment.tz.guess())
      .format(i18n.t('xExtraShortTime'))
  } else return 'N/A'
}

export function displayShortDateTimeWithTZ(date) {
  if (date) {
    return moment
      .utc(date)
      .tz(moment.tz.guess())
      .format(i18n.t('xShortDateTimeWithTZ'))
  } else {
    return 'N/A'
  }
}

export function displayShortTime(date) {
  if (date) {
    return moment
      .utc(date)
      .tz(moment.tz.guess())
      .format(i18n.t('xShortTime'))
  } else return 'N/A'
}

export function displayShortDateTime(date) {
  if (date) {
    return moment(date)
      .tz(moment.tz.guess())
      .format(i18n.t('xShortDateTime'))
  } else return 'N/A'
}

export function creditCardValidation(evt, cc) {
  evt = evt ? evt : window.event
  var charCode = evt.which ? evt.which : evt.keyCode
  if (charCode < 48 || charCode > 57 || (cc && cc.length > 15)) {
    evt.preventDefault()
  } else {
    return true
  }
}

export function cvvValidation(evt, cvv) {
  evt = evt ? evt : window.event
  var charCode = evt.which ? evt.which : evt.keyCode
  if (charCode < 48 || charCode > 57 || (cvv && cvv.length > 3)) {
    evt.preventDefault()
  } else {
    return true
  }
}

export function consentValidation(consent) {
  return consent
}

export function addPendingApparatus(apparatus) {
  var pendingApparatuses = JSON.parse(localStorage.getItem('pendingApparatuses'))
  if (pendingApparatuses == null) {
    pendingApparatuses = []
  }
  pendingApparatuses.push(apparatus)
  localStorage.setItem('pendingApparatuses', JSON.stringify(pendingApparatuses))
}

export function checkPendingApparatuses(apparatusIds, commit) {
  var pendingApparatuses = JSON.parse(localStorage.getItem('pendingApparatuses'))
  if (pendingApparatuses != null) {
    pendingApparatuses.forEach((pendingApparatus, index) => {
      if (apparatusIds.includes(pendingApparatus.id)) {
        pendingApparatuses.splice(index, 1)
      } else {
        commit('pushPendingApparatus', pendingApparatus.apparatusType)
      }
    })
    localStorage.setItem('pendingApparatuses', JSON.stringify(pendingApparatuses))
  }
}

export function subscriptionActive(subscription) {
  if (
    subscription &&
    subscription.status &&
    (subscription.status == Constants.SubscriptionActive ||
      subscription.status == Constants.SubscriptionPendingCancellation ||
      subscription.status == Constants.SubscriptionPendingTermination ||
      subscription.status == Constants.SubscriptionPendingSuspension)
  ) {
    return true
  }
  return false
}

export function subscriptionDetailActive(subscriptionStatus) {
  if (
    subscriptionStatus &&
    (subscriptionStatus == Constants.SubscriptionDetailPurchaseIntent ||
      subscriptionStatus == Constants.SubscriptionDetailActive ||
      subscriptionStatus == Constants.SubscriptionDetailPendingCancel ||
      subscriptionStatus == Constants.SubscriptionDetailPendingProductChange)
  ) {
    return true
  }
  return false
}

export function subscriptionDetailContainsApparatus(subscriptionApparatusList, apparatusId) {
  return subscriptionApparatusList?.some(apparatus => apparatus.apparatusId == apparatusId)
}

export function subscriptionPaid(subscription) {
  if (
    subscription &&
    subscription.type &&
    (subscription.type == Constants.PaidSubscription || subscription.type == Constants.ManagedSubscription)
  ) {
    return true
  }
  return false
}

export function DisplayAddress(data) {
  if (!data) return 'N/A'
  if (data.line2) {
    return (
      data.line1 + ' ' + data.line2 + ' ' + data.city + ', ' + data.region + ' ' + data.postalCode + ', ' + data.country
    )
  } else return data.line1 + ' ' + data.city + ', ' + data.region + ' ' + data.postalCode + ', ' + data.country
}

/**
 * Helper function that navigates user to the correct change email flow depending on if they have a B2C or Auth0 account
 *
 * @param {Object} store -Vuex store instance
 * @param {Function} t - Vue i18n translation function
 * @param {string} email - The account email that is trying to be changed
 * @param {string} destinationParam - The returnURI that specifies where the user should be returned once they are done with Auth0 email change
 */
function updateEmailBasedOnB2CAndAuth0(store, t, email, destinationParam) {
  store
    .dispatch('migrationStatus', email)
    .then(response => {
      if (response.data.status === Constants.MigrationStatusTypes.New) {
        // Auth0 account
        const changeEmailUrl = vueAppApiBaseAddress() + `Auth/Auth0/ChangeEmail?userEmail=${email}${destinationParam}`
        window.location.replace(changeEmailUrl)
      } else if (response.data.status === Constants.MigrationStatusTypes.Valid) {
        // B2C account
        window.location.replace(vueAppApiBaseAddress() + `Auth/UpdateProfile?email=${encodeURIComponent(email)}`)
      } else {
        // This is for AutoEnroll, Retry and Unknown cases and shouldn't happen since the user is already be signed in
        store.dispatch('displayToast', {
          title: t('xError'),
          message: t('xAnErrorHasOccurred'),
          variant: 'danger'
        })
      }
    })
    .catch(error => {
      store.dispatch('displayToast', {
        title: t('xError'),
        message: t('xAnErrorHasOccurred'),
        variant: 'danger'
      })
    })
}

/**
 * Updates the users email. Navigates the user to either the B2C or Auth0 email update flow depending of Feature Flag states and account type of user
 *
 * @param {string} email - The email that needs to be updated
 * @param {} currentAppConfig - The app config info needed to determine feature flag state
 */
export function updateEmail(email, currentAppConfig) {
  // This is used to specify Auth0's return URI. Don't update this unless we want to change where the user is dropped off after changing email
  const destination = this?.$route?.query?.destination || '/accountSettings/accountInformation'
  const destinationParam = `&destination=${encodeURIComponent(destination)}`

  if (useAuth0FeatureFlagEnabled(currentAppConfig)) {
    // Change email using Auth0 url
    window.location.assign(vueAppApiBaseAddress() + `Auth/Auth0/ChangeEmail?userEmail=${email}${destinationParam}`)
  } else if (useAuth0AndB2CFeatureFlagEnabled(currentAppConfig)) {
    // Need to check email type and navigate to correct authorizer
    updateEmailBasedOnB2CAndAuth0(this.$store, this.$t, email, destinationParam)
  } else {
    // Change email using B2C url
    window.location.replace(vueAppApiBaseAddress() + `Auth/UpdateProfile?email=${encodeURIComponent(email)}`)
  }
}

export function vueAppApiBaseAddress() {
  return document.cookie.indexOf(Constants.PreprodSlotName) != -1 ||
    window.location.href.indexOf(Constants.PreprodSlotName) != -1
    ? process.env.VUE_APP_API_BASE_ADDRESS_PREPROD
    : process.env.VUE_APP_API_BASE_ADDRESS
}

export function vueAppBaseAddress() {
  return document.cookie.indexOf(Constants.PreprodSlotName) != -1 ||
    window.location.href.indexOf(Constants.PreprodSlotName) != -1
    ? process.env.VUE_APP_BASE_ADDRESS_PREPROD
    : process.env.VUE_APP_BASE_ADDRESS
}

export function signOut() {
  this.$bvModal
    .msgBoxConfirm(this.$t('xAreYouSureLogout'), {
      size: 'sm',
      buttonSize: 'lg',
      okVariant: 'warning',
      okTitle: this.$t('xYes').toUpperCase(),
      cancelVariant: 'outline-warning',
      cancelTitle: this.$t('xNo').toUpperCase(),
      footerClass: 'p-2',
      hideHeader: true,
      centered: true
    })
    .then(value => {
      if (value) {
        this.$store.dispatch('clearAll')
        window.location.replace(vueAppApiBaseAddress() + `Auth/Auth0/SignOut`)
      }
    })
}

export function signOutAccountCreation() {
  const h = this.$createElement
  const modalMessage = h('div', { class: ['foobar'] }, [
    h('p', [this.$t('xAreYouSureLogoutAccountCreationStartText'), <br />, <br />, this.$t('xAreYouSureLogout')])
  ])
  this.$bvModal
    .msgBoxConfirm([modalMessage], {
      size: 'md',
      buttonSize: 'lg',
      okVariant: 'warning',
      okTitle: this.$t('xLogout'),
      cancelVariant: 'outline-warning',
      cancelTitle: this.$t('xCancel'),
      footerClass: 'p-2',
      hideHeader: true,
      centered: true
    })
    .then(value => {
      if (value) {
        this.$store.dispatch('clearAll')
        window.location.replace(vueAppApiBaseAddress() + `Auth/Auth0/SignOut`)
      }
    })
}

export function forceSignOut() {
  this.$store.dispatch('clearAll')
  window.location.replace(vueAppApiBaseAddress() + `Auth/Auth0/SignOut`)
}

export function getSortOrder(prop) {
  return function(a, b) {
    if (a[prop] > b[prop]) {
      return 1
    } else if (a[prop] < b[prop]) {
      return -1
    }
    return 0
  }
}

export function notImplemented() {
  this.$store.dispatch('displayToast', { title: this.$t('xError'), message: null, variant: 'danger' })
}

export function hasDevice(value) {
  if (value && value.deviceInfo && value.deviceInfo.deviceId && value.deviceInfo.deviceType) {
    return true
  } else return false
}

export function hasAssociatedAccount(value) {
  return value && value.organizationId ? true : false
}

export function getSubscriptionClass(subscriptions) {
  if (subscriptions && subscriptions[0].status == 'Active') return 'active-subscription'
  else return 'inactive-subscription'
}

export function genWithoutWifiModule(modelNumber) {
  let lastChar = modelNumber.slice(-1)
  if (lastChar == '8' || lastChar == '9') {
    return true
  } else return false
}

export function canHavePaidSubscription(accountInfo) {
  if (
    accountInfo &&
    accountInfo.address &&
    (accountInfo.address.country === 'US' || accountInfo.address.country === 'CA')
  ) {
    return true
  } else return false
}

export function tankCanHavePaidSubscription(accountInfo) {
  if (accountInfo && accountInfo.address && Constants.TanksAllowedCountries.includes(accountInfo.address.country)) {
    return true
  } else return false
}

export function trackAppInsightsEvent(name, properties) {
  this.$appInsights.trackEvent({
    name: name,
    properties: properties
  })
}

export function subscriptionPaidAndNotManaged(subscription) {
  if (subscription && subscription.type && subscription.type == Constants.PaidSubscription) {
    return true
  }
  return false
}

export function subscriptionManaged(subscription) {
  if (subscription && subscription.type && subscription.type == Constants.ManagedSubscription) {
    return true
  }
  return false
}

export function messageCenterEnabled(currentAppConfig) {
  return currentAppConfig && currentAppConfig.featureFlags && currentAppConfig.featureFlags[Constants.MessageCenterFF]
}

export function g3DeviceFeatureFlagEnabled(currentAppConfig) {
  return currentAppConfig?.featureFlags?.[Constants.G3DeviceFeatureFlag]
}
export function useAuth0FeatureFlagEnabled(currentAppConfig) {
  return currentAppConfig?.featureFlags?.[Constants.useAuth0FeatureFlag]
}
export function useAuth0AndB2CFeatureFlagEnabled(currentAppConfig) {
  return currentAppConfig?.featureFlags?.[Constants.useAuth0AndB2CFeatureFlag]
}

export function billingMaintenanceFeatureFlagEnabled(currentAppConfig) {
  return currentAppConfig?.featureFlags?.[Constants.BillingMigrationFeatureFlag]
}

export function showBannerMessage(bannerMessage) {
  if (bannerMessage) {
    let now = moment().toISOString()
    if (now > bannerMessage.StartDate && now < bannerMessage.EndDate) return true
  } else return false
}

export function getBannerVariant(bannerMessage) {
  if (bannerMessage) {
    if (bannerMessage.Category == 0) return 'warning'
  }
  return ''
}

export function getBannerIconClassAndColor(bannerMessage) {
  if (bannerMessage) {
    if (bannerMessage.Category == 0) return 'fas fa-exclamation-triangle banner-category-warning'
  }
  return ''
}

export function documentsStatementsPageEnabled(currentAppConfig) {
  return (
    currentAppConfig && currentAppConfig.featureFlags && currentAppConfig.featureFlags[Constants.DocumentsStatementsFF]
  )
}

export function createEventLogObjectFromDashboardPage(apparatus, profile, isImpersonating, eventType) {
  let eventToLog = {
    event: eventType,
    ownerOrganizationId: profile?.organizationId,
    apparatusId: apparatus?.apparatusId,
    userId: profile?.userId,
    properties: {
      apparatusType: apparatus?.type == Constants.FuelTankApparatusType ? 'FuelTank' : 'Generator',
      deviceType:
        apparatus?.type == Constants.FuelTankApparatusType
          ? 'tankutility'
          : properties.filter(x => x.type == Constants.ApparatusPropertyDevice)[0]?.value?.deviceType,
      deviceId:
        apparatus?.type == Constants.FuelTankApparatusType
          ? null
          : properties.filter(x => x.type == Constants.ApparatusPropertyDevice)[0]?.value?.deviceId,
      adminInitiated: isImpersonating,
      isDealerManaged: apparatus?.isDealerManaged
    }
  }
  return eventToLog
}

export function createEventLogObjectFromSubscriptionsPage(
  apparatus,
  subscription,
  profile,
  isImpersonating,
  eventType,
  newSubscriptionId,
  optionalReason,
  cancelDetails = null,
  couponCode = null
) {
  let eventToLog = {
    event: eventType,
    ownerOrganizationId: profile?.organizationId,
    apparatusId: apparatus?.apparatusId,
    userId: profile?.userId,
    properties: {
      deviceType: apparatus?.deviceType,
      adminInitiated: isImpersonating,
      reason: optionalReason,
      details: cancelDetails,
      oldSubscriptionId: subscription && subscription[0] ? subscription[0]?.productId : null,
      newSubscriptionId: newSubscriptionId,
      couponCode: couponCode ? couponCode : null
    }
  }
  return eventToLog
}

export function createEventLogObjectFromAdmin(apparatus, subscription, profile, eventType, newSubscriptionId = null) {
  let eventToLog = {
    event: eventType,
    ownerOrganizationId: apparatus?.organizationId,
    apparatusId: apparatus?.apparatusId,
    userId: apparatus?.userId,
    properties: {
      deviceId: apparatus?.deviceInfo?.deviceId,
      deviceType: apparatus?.deviceInfo?.deviceType,
      oldSubscriptionId: subscription && subscription.activeProduct ? subscription?.activeProduct[0]?.productId : null,
      newSubscriptionId: newSubscriptionId,
      adminUserId: profile?.userId,
      adminInitiated: true
    }
  }
  return eventToLog
}

export function getEventType(oldProductId, newProductId) {
  if (oldProductId.includes('annual') || (oldProductId.includes('month') && newProductId.includes('free'))) {
    return Constants.DowngradeEventType
  } else return Constants.UpgradeEventType
}

export function validAddress(address) {
  if (address && address.line1 && address.region && address.city && address.country) return true
  return false
}

export function getOS() {
  if (navigator.userAgent.toLowerCase().includes('windows')) {
    return 'Windows'
  } else if (navigator.userAgent.toLowerCase().includes('android')) {
    return 'Android'
  } else if (navigator.userAgent.toLowerCase().match(/(ios)|(ipad)|(iphone)/)) {
    return 'iOS'
  } else {
    return 'Unknown'
  }
}

export function PortablesEnabledFF(currentAppConfig) {
  return (
    currentAppConfig &&
    currentAppConfig.featureFlags &&
    currentAppConfig.featureFlags[Constants.AddPortablesGenBtOnDashboardFF]
  )
}

export function openModal(elementId) {
  let element = document.getElementById(elementId)
  if (element) element.style.display = 'block'
}

export function closeModal(elementId) {
  let element = document.getElementById(elementId)
  if (element) element.style.display = 'none'
}

export function copyToClipboard(copyText) {
  if (copyText) {
    navigator.clipboard.writeText(copyText)
    this.$store.dispatch('displayToast', {
      title: this.$t('xSuccess'),
      message: this.$t('xInfoCopiedToClipboard'),
      variant: 'success'
    })
  }
}

/** Given an apparatusId and a list of subscriptions from the getSubscriptionDetails details endpoint data, return the subscription that matches with the apparatusId, if it exists. */
export function getSubscriptionForApparatus(apparatusId, subscriptionList) {
  for (const subscription of subscriptionList ?? []) {
    for (const apparatus of subscription.apparatuses) {
      if (apparatus.apparatusId === apparatusId) {
        return subscription
      }
    }
  }
  return
}

/** Given an apparatusId and a legacy billing data from the getSubscriptionDetails details endpoint data, return the subscription info that matches with the apparatusId, if it exists. */
export function getLegacySubscriptionForApparatus(apparatusId, legacyBillingAccountData) {
  const products = legacyBillingAccountData?.products
  const thisProduct = products?.filter(product => product.apparatusId === apparatusId)[0]
  return thisProduct
}

/** Given a numeric value, convert that into the appropriate currency format for the locale - note: taken from the filter function formatCurrency() for use in string interpolation/translation */
export function getCurrencyString(value) {
  if (!value) return 'N/A'
  return Intl.NumberFormat(i18n.t('xLocale'), {
    style: 'currency',
    currency: i18n.t('xCurrency')
  }).format(value)
}

export function isHomePremiumSubscription(subscriptionProductId) {
  return (
    subscriptionProductId === Constants.HomePremiumOneMonthlyProductId ||
    subscriptionProductId === Constants.HomePremiumOneYearlyProductId ||
    subscriptionProductId === Constants.HomePremiumMultiHomeMonthlyProductId ||
    subscriptionProductId === Constants.HomePremiumMultiHomeYearlyProductId
  )
}

export function isSingleApparatusSubscription(subscriptionProductId) {
  return (
    subscriptionProductId === Constants.SingleGeneratorMonthlyProductId ||
    subscriptionProductId === Constants.SingleGeneratorYearlyProductId ||
    subscriptionProductId === Constants.SingleFuelMonitorMonthlyProductId ||
    subscriptionProductId === Constants.SingleFuelMonitorYearlyProductId
  )
}

export function isSingleGenSubscription(subscriptionProductId) {
  return (
    subscriptionProductId === Constants.SingleGeneratorMonthlyProductId ||
    subscriptionProductId === Constants.SingleGeneratorYearlyProductId
  )
}

export function isSingleFMSubscription(subscriptionProductId) {
  return (
    subscriptionProductId === Constants.SingleFuelMonitorMonthlyProductId ||
    subscriptionProductId === Constants.SingleFuelMonitorYearlyProductId
  )
}

export function isSingleHomeSubscription(subscriptionProductId) {
  return (
    subscriptionProductId === Constants.HomePremiumOneMonthlyProductId ||
    subscriptionProductId === Constants.HomePremiumOneYearlyProductId
  )
}

export function isMultiHomeSubscription(subscriptionProductId) {
  return (
    subscriptionProductId === Constants.HomePremiumMultiHomeMonthlyProductId ||
    subscriptionProductId === Constants.HomePremiumMultiHomeYearlyProductId
  )
}

export function canDowngradeToSingleHomePlan(subscriptionPlan) {
  return (
    !canDowngradeToSingleGeneratorPlan(subscriptionPlan) &&
    !canDowngradeToSingleFuelMonitorPlan(subscriptionPlan) &&
    subscriptionPlan?.apparatuses.filter(apparatus => apparatus.type === Constants.HsbApparatusType).length > 0 &&
    subscriptionPlan?.apparatuses.filter(apparatus => apparatus.type === Constants.HsbApparatusType).length <= 1 &&
    subscriptionPlan?.apparatuses.filter(apparatus => apparatus.type === Constants.FuelTankApparatusType).length > 0 &&
    subscriptionPlan?.apparatuses.filter(apparatus => apparatus.type === Constants.FuelTankApparatusType).length <= 2 &&
    subscriptionPlan?.product.productId !== Constants.HomePremiumOneYearlyProductId &&
    subscriptionPlan?.product.productId !== Constants.HomePremiumOneMonthlyProductId
  )
}

export function canDowngradeToSingleGeneratorPlan(subscriptionPlan) {
  return (
    subscriptionPlan?.apparatuses.length === 1 &&
    subscriptionPlan?.apparatuses.find(apparatus => apparatus.type === Constants.HsbApparatusType) &&
    subscriptionPlan?.product.productId !== Constants.SingleGeneratorMonthlyProductId &&
    subscriptionPlan?.product.productId !== Constants.SingleGeneratorYearlyProductId
  )
}

export function canDowngradeToSingleFuelMonitorPlan(subscriptionPlan) {
  return (
    subscriptionPlan?.apparatuses.length === 1 &&
    subscriptionPlan?.apparatuses.find(apparatus => apparatus.type === Constants.FuelTankApparatusType) &&
    subscriptionPlan?.product.productId !== Constants.SingleFuelMonitorMonthlyProductId &&
    subscriptionPlan?.product.productId !== Constants.SingleFuelMonitorYearlyProductId
  )
}

export function planEligibleForDowngrade(subscriptionPlan) {
  if (
    (subscriptionPlan?.product.productId === Constants.HomePremiumMultiHomeMonthlyProductId ||
      subscriptionPlan?.product.productId === Constants.HomePremiumMultiHomeYearlyProductId) &&
    (canDowngradeToSingleHomePlan(subscriptionPlan) ||
      canDowngradeToSingleGeneratorPlan(subscriptionPlan) ||
      canDowngradeToSingleFuelMonitorPlan(subscriptionPlan))
  ) {
    return true
  } else if (
    (subscriptionPlan?.product.productId === Constants.HomePremiumOneMonthlyProductId ||
      subscriptionPlan?.product.productId === Constants.HomePremiumOneYearlyProductId) &&
    (canDowngradeToSingleGeneratorPlan(subscriptionPlan) || canDowngradeToSingleFuelMonitorPlan(subscriptionPlan))
  ) {
    return true
  } else {
    return false
  }
}

export function isDealerManaged(subscriptionProductId) {
  return (
    subscriptionProductId === Constants.DealerManagedProductId ||
    subscriptionProductId === Constants.TankUtilityDealerManagedProductId
  )
}

export function isSubscriptionExpired({ apparatus, subscriptionDetails, legacySubscriptionDetails }) {
  // check sub status on new organization sub data.
  if (subscriptionDetails) {
    // Cancelled FMs are treated as fully cancelled.
    if (
      apparatus.type === Constants.FuelTankApparatusType &&
      subscriptionDetails.status === Constants.SubscriptionDetailCanceled
    ) {
      return true
    }
    if (
      apparatus.isDealerManaged &&
      subscriptionDetails.store === Constants.DealerSubscriptionStore &&
      subscriptionDetails.status === Constants.SubscriptionDetailCanceled
    ) {
      return true
    }
    return false
  }

  // If there is no new organization sub, check if there is legacy billing info.
  // We treat cancelled HSBs as basic, so we only care if a FM is legacy and cancelled.
  if (legacySubscriptionDetails) {
    if (!subscriptionActive(legacySubscriptionDetails) && apparatus.type === Constants.FuelTankApparatusType) {
      return true
    }

    const hasDealerManagedGen = apparatus.type === Constants.HsbApparatusType && apparatus.isDealerManaged

    const hasInactiveDealerSubscription =
      legacySubscriptionDetails.productId === Constants.DealerManagedProductId &&
      !subscriptionActive(legacySubscriptionDetails)

    if (hasDealerManagedGen && hasInactiveDealerSubscription) {
      return true
    }
  }
  //False because no subscription present
  return false
}

export function isInDealerAndNonDealerSubscription(apparatus, subscriptionInfo) {
  const currentDealerSubscription = subscriptionInfo.find(
    subscription =>
      subscription.store === Constants.DealerSubscriptionStore &&
      subscription.status !== Constants.SubscriptionDetailCanceled &&
      subscription.apparatuses.find(
        subscriptionApparatus => subscriptionApparatus.apparatusId === apparatus.apparatusId
      )
  )
  const currentNonDealerSubscription = subscriptionInfo.find(
    subscription =>
      subscription.store !== Constants.DealerSubscriptionStore &&
      subscription.status !== Constants.SubscriptionDetailCanceled &&
      subscription.apparatuses.find(
        subscriptionApparatus => subscriptionApparatus.apparatusId === apparatus.apparatusId
      )
  )
  if (currentDealerSubscription && currentNonDealerSubscription) {
    const dealerRolloverInfo = {
      apparatusToRollover: apparatus,
      nonDealerManagedSubscription: currentNonDealerSubscription
    }

    return dealerRolloverInfo
  }

  return undefined
}

//this function does not account for any dealer related subscription issues
export function doesAccountHaveSubscriptionIssues({ apparatusList, subscriptionsData }) {
  //Check for an active IAP subscription on the account that isn't a dealer sub
  const currentNonCanceledIAPSubscriptionOnAccount = subscriptionsData?.subscriptions.find(
    s => s.status !== Constants.SubscriptionDetailCanceled && s.store !== Constants.DealerSubscriptionStore
  )

  //Check for an active Legacy subscription on the account
  const currentNonCanceledLegacySubscriptionOnAccount = subscriptionsData?.legacyBillingProducts?.products.find(
    s => s.status !== Constants.SubscriptionCancelled
  )

  for (const apparatus of apparatusList) {
    // Get the most relevant subscription for the given apparatus
    let subscription
    if (subscriptionsData?.subscriptions) {
      subscription = getSubscriptionForApparatus(apparatus.apparatusId, subscriptionsData?.subscriptions)
    }

    // Get the legacy subscription for the given apparatus
    let legacySubscription
    if (!subscription && subscriptionsData?.legacyBillingProducts) {
      legacySubscription = getLegacySubscriptionForApparatus(
        apparatus.apparatusId,
        subscriptionsData?.legacyBillingProducts
      )
    }

    const apparatusNotOnASubscription =
      (!subscription || subscription.status === Constants.SubscriptionDetailCanceled) &&
      (!legacySubscription || legacySubscription.status === Constants.SubscriptionCancelled)

    if (apparatus.type === Constants.FuelTankApparatusType && apparatusNotOnASubscription) {
      return true
    }

    if (!apparatus.isDealerManaged) {
      //check for a non canceled subscription that the apparatus must be on
      if (
        (currentNonCanceledIAPSubscriptionOnAccount || currentNonCanceledLegacySubscriptionOnAccount) &&
        apparatusNotOnASubscription
      ) {
        return true
      }
    }
  }

  return false
}

const POLLING_TIME = 1000
const MAX_POLL_RETRIES = 4

/**
 * Polling method that calls a provided GET request once every second for 5 seconds until the GET request returns data that matches what the user submitted
 * @param {String} requestToPoll - the GET request to check against the user's submitted data
 * @param {Object} requestParameters - any parameters needed for the aforementioned GET request
 * @param {Function} validator - method for validating whether new data matches what is expected
 * @param {string} spinnerModalSize - size of spinner modal. Currently supports 'md' for medium and 'lg' for large. If not provided, defaults to 'md'.
 * @returns Promise
 */
export function pollForSubmissionUpdate(requestToPoll, requestParameters, validator, spinnerModalSize) {
  // show spinner
  if (spinnerModalSize === 'lg') {
    this.openModal('globalSpinnerModalLarge')
  } else {
    this.openModal('globalSpinnerModalMedium')
  }
  // note that mixins apparently need to be defined as above, and cannot be arrow functions or else they won't have access to the Vue context. This took me quite a while to figure out. :)
  return new Promise((resolve, reject) => {
    // IIFE - poll() immediately invokes itself and recurs as needed
    ;(function poll(attempt) {
      this.$store
        .dispatch(requestToPoll, requestParameters)
        .then(result => {
          if (result?.data) {
            // check against submitted data using provided validator
            if (validator(result.data)) {
              // if all is well, resolve the promise and stop making requests
              return resolve(result.data)
            }
          }

          // if we are still waiting for a success in the validator, go ahead and make another request in 1 second
          if (attempt > MAX_POLL_RETRIES) {
            // if it's been 5 attempts/seconds and there's still no successful validation, resolve as false (resolving because we don't want to mistake this as an error)
            resolve(false)
          } else {
            setTimeout(() => {
              // need to bind this to keep access to $store and $bvModal through multiple iterations
              poll.bind(this)(++attempt)
            }, POLLING_TIME)
          }
        })
        .catch(err => {
          reject(err)
        })
      // binding the IIFE for the same reason as above
    }.bind(this)(0))
  }).finally(() => {
    if (spinnerModalSize === 'lg') {
      this.closeModal('globalSpinnerModalLarge')
    } else {
      this.closeModal('globalSpinnerModalMedium')
    }
  })
}

/** Returns a formatted string of the format MM/DD/YYYY representing the end/renewal date of the subscription based on the purchase date and cadence. */
export const calculateSubscriptionEndDate = (purchasedDate, subscriptionDuration) => {
  const shortDate = displayShortDate(purchasedDate)
  const dateParts = shortDate.split('/')
  let month = parseInt(dateParts[0])
  let day = parseInt(dateParts[1])
  let year = parseInt(dateParts[2])
  let subscriptionDurationInt = Number(subscriptionDuration)

  month = month + subscriptionDurationInt
  if (month > 12) {
    month -= 12
    year += 1
  }
  const monthString = String(month).padStart(2, '0')
  const dayString = String(day).padStart(2, '0')
  const yearString = String(year)

  return `${monthString}/${dayString}/${yearString}.`
}

/**
 * Checks if any pending subscription changes have been acknowledged by the platform.
 * If found in the fetched subscription data, removes them from the global store so that the blue banner goes away.
 * Used on the PlanDetails (SettingsSubscriptions) page and Dashboard.
 */
export function checkAndClearCompletedPendingChanges(subscriptionData) {
  const pendingChanges = this.$store.getters.pendingSubscriptionChanges
  if (pendingChanges?.length === 0) {
    return
  }
  if (!subscriptionData || subscriptionData.subscriptions?.length === 0) {
    return
  }
  const pendingChange = pendingChanges[0] // There is only ever one pending change because if you made ANOTHER pending change, it would overwrite what's already there.

  if (subscriptionData.subscriptions.every(sub => sub.status === Constants.SubscriptionDetailCanceled)) {
    // If the user only has cancelled subscriptions and the expected pending change was a cancel, don't show the blue banner.
    // For upgrades, the new subscription might still be processing (like going from having no plan to a premium plan, there would be no existing sub).
    if (pendingChange.isPendingCancel) {
      this.$store.dispatch('deletePendingSubscriptionChanges')
    }
    return
  }

  // Find the most recent (first) web store, non-dealer-managed subscription
  const newestWebSubscription = subscriptionData.subscriptions?.find(
    sub => sub.store === Constants.WebSubscriptionStore && !isDealerManaged(sub?.product?.productId)
  )

  if (!newestWebSubscription) return

  if (pendingChange.isPendingCancel) {
    const foundCancelAcknowledgement = subscriptionData.subscriptions?.some(
      sub =>
        newestWebSubscription.status === Constants.SubscriptionDetailPendingCancel ||
        newestWebSubscription.status === Constants.SubscriptionDetailCanceled
    )

    if (foundCancelAcknowledgement) {
      this.$store.dispatch('deletePendingSubscriptionChanges')
    }
  }
  // For upgrades, updates, cadence changes, and downgrades, check that apparatuses are in subscription with expected product
  else {
    const foundMatchingSub = subscriptionData.subscriptions?.find(sub => {
      const hasApparatuses = pendingChange.apparatusIds.every(apparatusId =>
        sub.apparatuses?.some(apparatus => apparatus.apparatusId === apparatusId)
      )

      const hasExpectedProduct =
        pendingChangeIsAlreadyActive(sub, pendingChange.pendingProductId) ||
        pendingChangeIsPendingButAcknowledged(sub, pendingChange.pendingProductId)

      return hasApparatuses && hasExpectedProduct && subscriptionDetailActive(sub.status)
    })

    if (foundMatchingSub) {
      this.$store.dispatch('deletePendingSubscriptionChanges')
    }
  }
}

/** Returns true if the current subscription status indicates a pending change and there is a pending product entry that matches the expected pending product id. */
export function pendingChangeIsPendingButAcknowledged(currentSubscription, pendingChangeProductId) {
  return (
    currentSubscription.status === Constants.SubscriptionDetailPendingProductChange &&
    currentSubscription.pendingProduct?.productId === pendingChangeProductId
  )
}

/** Returns true if the current subscription is Active status and the productId matches what we expected for a pending product id, indicting that the pending change has taken effect. */
export function pendingChangeIsAlreadyActive(currentSubscription, pendingChangeProductId) {
  return (
    currentSubscription.status === Constants.SubscriptionDetailActive &&
    currentSubscription.product?.productId === pendingChangeProductId
  )
}

export function doesRequireUpgrade(subscriptions, apparatusesToUpgrade) {
  const existingSubscription = subscriptions?.find(
    subscription => subscription.status !== Constants.SubscriptionDetailCanceled
  )
  if (!existingSubscription) {
    return true
  }

  const existingHSBCount = apparatusesToUpgrade?.reduce((sum, app) => {
    if (app.type === Constants.HsbApparatusType) {
      return sum + 1
    }

    return sum
  }, 0)
  const existingTankCount = apparatusesToUpgrade?.reduce((sum, app) => {
    if (app.type === Constants.FuelTankApparatusType) {
      return sum + 1
    }

    return sum
  }, 0)

  const appHSBString = Constants.ApparatusTypeToString[Constants.HsbApparatusType]
  const appTankString = Constants.ApparatusTypeToString[Constants.FuelTankApparatusType]

  const subscriptionHSBLimit = existingSubscription.product?.apparatusTypesMax?.[appHSBString] ?? 0
  const subscriptionTankLimit = existingSubscription.product?.apparatusTypesMax?.[appTankString] ?? 0
  return existingHSBCount > subscriptionHSBLimit || existingTankCount > subscriptionTankLimit
}

Vue.mixin({
  methods: {
    validState: function(formField) {
      return formField.$dirty ? !formField.$error : null
    },
    status(validation) {
      return {
        'is-invalid': validation.$error,
        'is-valid': validation.$dirty
      }
    },
    addPendingApparatus,
    canHavePaidSubscription,
    checkPendingApparatuses,
    closeModal,
    copyToClipboard,
    createEventLogObjectFromAdmin,
    createEventLogObjectFromDashboardPage,
    createEventLogObjectFromSubscriptionsPage,
    creditCardValidation,
    cvvValidation,
    consentValidation,
    deepTrim,
    DisplayAddress,
    displayExtraShortTimeWithTZ,
    displayLongDateTime,
    displayShortDate,
    displayShortDateTime,
    displayShortDateTimeWithTZ,
    displayShortTime,
    documentsStatementsPageEnabled,
    forceSignOut,
    genWithoutWifiModule,
    getBannerIconClassAndColor,
    getBannerVariant,
    getCurrencyString,
    getEventType,
    getOS,
    getSortOrder,
    getSubscriptionClass,
    getSubscriptionForApparatus,
    getLegacySubscriptionForApparatus,
    isDealerManaged,
    isHomePremiumSubscription,
    isSingleApparatusSubscription,
    isSingleGenSubscription,
    isSingleFMSubscription,
    isSingleHomeSubscription,
    isMultiHomeSubscription,
    canDowngradeToSingleHomePlan,
    canDowngradeToSingleGeneratorPlan,
    canDowngradeToSingleFuelMonitorPlan,
    planEligibleForDowngrade,
    hasAssociatedAccount,
    hasDevice,
    messageCenterEnabled,
    notImplemented,
    openModal,
    PortablesEnabledFF,
    showBannerMessage,
    signOut,
    signOutAccountCreation,
    subscriptionActive,
    subscriptionDetailActive,
    subscriptionDetailContainsApparatus,
    subscriptionManaged,
    subscriptionPaid,
    subscriptionPaidAndNotManaged,
    trackAppInsightsEvent,
    updateEmail,
    validAddress,
    g3DeviceFeatureFlagEnabled,
    vueAppApiBaseAddress,
    vueAppBaseAddress,
    isSubscriptionExpired,
    isInDealerAndNonDealerSubscription,
    doesAccountHaveSubscriptionIssues,
    pollForSubmissionUpdate,
    calculateSubscriptionEndDate,
    checkAndClearCompletedPendingChanges,
    pendingChangeIsPendingButAcknowledged,
    pendingChangeIsAlreadyActive,
    doesRequireUpgrade,
    useAuth0AndB2CFeatureFlagEnabled,
    useAuth0FeatureFlagEnabled,
    billingMaintenanceFeatureFlagEnabled
  }
})
